module.exports = __webpack_public_path__ + "img/1350.591fc3ab.gif";